import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import StockList from '../../modules/stock/components/StockList';

export function StockPage() {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'menu.stock' })}
      </PageTitle>
      <div className="row">
        <div className="col-12">
          <StockList />
        </div>
      </div>
    </>
  );
}
